import { getAccessToken, type FleetSummary, type UserTaskSummary } from '@autoplan/common'

function getDefaultUrl(): string {
  const hostname = window.location.hostname
  return `https://${hostname}/api/web-home/frontend`
}

const defaultUrl = getDefaultUrl()

function headers() {
  const token = getAccessToken()
  return token ? { Authorization: `Bearer ${token}` } : undefined
}

export async function fetchFleetSummary(): Promise<FleetSummary> {
  const response = await fetch(`${defaultUrl}/fleet/summary`, { headers: headers() })

  if (!response.ok) throw new Error(`Failed to fetch fleet summary: ${response.status} ${response.statusText}`)
  return response.json()
}

export type ContactRequest = {
  phone: string
  company: string
  message: string
}

export async function fetchUserSummary(): Promise<UserTaskSummary> {
  const response = await fetch(`${defaultUrl}/user/summary`, { headers: headers() })

  if (!response.ok) throw new Error(`Failed to fetch user summary: ${response.status} ${response.statusText}`)
  return response.json()
}

export async function sendContactRequest(body: ContactRequest): Promise<void> {
  const response = await fetch(`${defaultUrl}/contact`, {
    method: 'POST',
    headers: {
      ...headers(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })

  if (!response.ok) throw new Error(`Failed to send contact request: ${response.status} ${response.statusText}`)
}
